export var ServiceOfferingExceptionCodesApi;
(function (ServiceOfferingExceptionCodesApi) {
    ServiceOfferingExceptionCodesApi["SERVICE_OFFERING_NOT_FOUND"] = "service_offering_not_found";
    ServiceOfferingExceptionCodesApi["SERVICE_OFFERING_IS_INVALID"] = "service_offering_is_invalid";
    ServiceOfferingExceptionCodesApi["SERVICE_OFFERING_ATTACHMENT_NOT_FOUND"] = "service_offering_attachment_not_found";
    ServiceOfferingExceptionCodesApi["INVALID_SERVICE_OFFERING_JOB_ID"] = "invalid_service_offering_job_id";
    ServiceOfferingExceptionCodesApi["SERVICE_OFFERING_IS_NOT_ACTIVE"] = "service_offering_is_not_active";
    ServiceOfferingExceptionCodesApi["MULTIPLE_CREATOR_IDS_WITH_INVALID_STATUS"] = "multiple_creator_ids_with_invalid_status";
    ServiceOfferingExceptionCodesApi["SHOP_NOT_FOUND"] = "shop_not_found";
    ServiceOfferingExceptionCodesApi["SHOP_CATEGORY_NOT_FOUND"] = "shop_category_not_found";
    ServiceOfferingExceptionCodesApi["SHOP_CATEGORY_SERVICE_NOT_FOUND"] = "shop_category_service_not_found";
    ServiceOfferingExceptionCodesApi["EXCEEDED_ALLOWED_SHOP_COUNT"] = "exceeded_allowed_shop_count";
    ServiceOfferingExceptionCodesApi["EXCEEDED_ALLOWED_SHOP_CATEGORY_COUNT"] = "exceeded_allowed_shop_category_count";
    ServiceOfferingExceptionCodesApi["EXCEEDED_ALLOWED_SHOP_CATEGORY_SERVICE_COUNT"] = "exceeded_allowed_shop_category_service_count";
    ServiceOfferingExceptionCodesApi["UNKNOWN_ERROR"] = "unknown_error";
    ServiceOfferingExceptionCodesApi["INVALID_REQUEST"] = "invalid_request";
})(ServiceOfferingExceptionCodesApi || (ServiceOfferingExceptionCodesApi = {}));
export var ServiceOfferingStatusApi;
(function (ServiceOfferingStatusApi) {
    ServiceOfferingStatusApi["DRAFT"] = "draft";
    ServiceOfferingStatusApi["ACTIVE"] = "active";
    ServiceOfferingStatusApi["DELETED"] = "deleted";
    ServiceOfferingStatusApi["HIDDEN"] = "hidden";
})(ServiceOfferingStatusApi || (ServiceOfferingStatusApi = {}));
export var ServiceOfferingShopCategoryServicePriceTypeApi;
(function (ServiceOfferingShopCategoryServicePriceTypeApi) {
    ServiceOfferingShopCategoryServicePriceTypeApi["SUBSCRIPTION_ONLY_MONTHLY"] = "subscription_only_monthly";
    ServiceOfferingShopCategoryServicePriceTypeApi["SUBSCRIPTION_ONLY_ANNUALLY"] = "subscription_only_annually";
    ServiceOfferingShopCategoryServicePriceTypeApi["SUBSCRIPTION_ONLY_WEEKLY"] = "subscription_only_weekly";
    ServiceOfferingShopCategoryServicePriceTypeApi["HOURLY_ONLY"] = "hourly_only";
    ServiceOfferingShopCategoryServicePriceTypeApi["HAS_FIXED_ITEMS"] = "has_fixed_items";
})(ServiceOfferingShopCategoryServicePriceTypeApi || (ServiceOfferingShopCategoryServicePriceTypeApi = {}));
